import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Github } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 py-6 mb-32 sm:mb-0">
      <div className="container mx-auto px-4 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm">
        {/* Gauche : Copyright */}
        <p className="text-gray-500 font-medium text-center sm:text-left">
          &copy; {currentYear} Hubvex. Tous droits réservés.
        </p>

        {/* Centre : Mentions Légales & Contact avec séparateur */}
        <div className="flex items-center gap-6 text-gray-500 font-medium">
          <Link to="/mentions-legales" className="hover:text-accent transition-colors">
            Mentions Légales
          </Link>
          <span className="w-px h-4 bg-gray-300" />
          <Link to="/contact" className="hover:text-accent transition-colors">
            Contact
          </Link>
        </div>

        {/* Droite : Réseaux sociaux avec cercle et bordure grise, icônes en accent */}
        <div className="flex items-center gap-3">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-9 h-9 rounded-full border-2 border-gray-300 text-accent hover:border-accent hover:text-accent/80 transition-all duration-200 hover:bg-accent/5"
            aria-label="Facebook"
          >
            <Facebook className="w-4 h-4" />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-9 h-9 rounded-full border-2 border-gray-300 text-accent hover:border-accent hover:text-accent/80 transition-all duration-200 hover:bg-accent/5"
            aria-label="Twitter"
          >
            <Twitter className="w-4 h-4" />
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-9 h-9 rounded-full border-2 border-gray-300 text-accent hover:border-accent hover:text-accent/80 transition-all duration-200 hover:bg-accent/5"
            aria-label="LinkedIn"
          >
            <Linkedin className="w-4 h-4" />
          </a>
          <a
            href="https://github.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-9 h-9 rounded-full border-2 border-gray-300 text-accent hover:border-accent hover:text-accent/80 transition-all duration-200 hover:bg-accent/5"
            aria-label="GitHub"
          >
            <Github className="w-4 h-4" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;